import { gaEvent } from 'src/utils'

import { parseOrderList } from './utils'
import { CartProductItem } from '../../types'
import { getTotalPriceByCart } from '../../utils'

/**
 * Parâmetro para {@link purchaseEvent}
 */
export type PurchaseEvent = {
  id: string
  orderList: CartProductItem[]
}

/**
 * @deprecated usar function {@link ecommerceEvent} com eventName 'purchase'
 */
export const eventData = ({ id, orderList }: PurchaseEvent) => ({
  event: 'purchase',
  'event-category': 'purchase',
  'event-action': 'click',
  'event-label': 'pedir-para-re',
  ecommerce: {
    purchase: {
      actionField: {
        id,
        revenue: getTotalPriceByCart(orderList),
      },
      products: parseOrderList(orderList),
    },
  },
})

/**
 * @deprecated usar function {@link ecommerceEvent} com eventName 'purchase'
 * [TARGET]: registrar dados de pedido
 *
 * [CONTEXTO]: deve ser utilizada para identificar um pedido realizado pelo cliente final.
 *
 * [REGRAS]:
 * - Registra 'preco-da-revendedora' na Dimension.RESELLER_PRICE do produto, caso haja tag marcada como 'Preço do Revendedor'
 * - Registra 'pronta-entrega' ou 'nao-pronta-entrega' na Dimension.PROMPT_DELIVERY do produto de acordo com a disponibilidade
 *
 * @param config - Objeto com dados do evento
 */
export const purchaseEvent = ({ id, orderList }: PurchaseEvent) => {
  gaEvent(eventData({ id, orderList }))
}
